import { Fragment } from 'react';

import RichText from 'molecules/RichText';
import TwoColumnGrid from 'molecules/TwoColumnGrid';

import styles from 'components/twoColumnCards/twocolumncards.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { TwoColumnCardProps } from 'components/twoColumnCards/config';
import type { ElementType, FC } from 'react';

const TwoColumnCard: FC<TwoColumnCardProps> = ({ cards }) => (
  <div className={styles.container}>
    {isNonEmptyArray(cards) && (
      <TwoColumnGrid width="wide">
        {cards.map(({ headingTag, heading, body }) => {
          const HeadingTag = (headingTag || 'h3') as ElementType;

          return (
            <Fragment key={heading}>
              {heading && <HeadingTag className={styles.heading}>{heading}</HeadingTag>}
              {body && <RichText content={body} className={styles.richText} />}
            </Fragment>
          );
        })}
      </TwoColumnGrid>
    )}
  </div>
);

export default TwoColumnCard;
